import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from './components/ui/sonner';
import { CartProvider } from './context/CartContext';
import { ScrollToTop } from './components/ScrollToTop';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { PolicyModal } from './components/modals/PolicyModals';
import { Home } from './pages/Home';
import { Category } from './pages/Category';
import { Product } from './pages/Product';
import { Cart } from './pages/Cart';
import { Checkout } from './pages/Checkout';
import { OrderConfirmation } from './pages/OrderConfirmation';
import { About } from './pages/About';
import { Contact } from './pages/Contact';

function App() {
  const [policyModal, setPolicyModal] = useState({ isOpen: false, type: null });

  const openPolicy = (type) => {
    setPolicyModal({ isOpen: true, type });
  };

  const closePolicy = () => {
    setPolicyModal({ isOpen: false, type: null });
  };

  return (
    <CartProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/category/:categoryId" element={<Category />} />
              <Route path="/product/:productId" element={<Product />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order-confirmation" element={<OrderConfirmation />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer onOpenPolicy={openPolicy} />
          <PolicyModal 
            isOpen={policyModal.isOpen} 
            onClose={closePolicy} 
            policyType={policyModal.type} 
          />
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </div>
    </CartProvider>
  );
}

export default App;
